// material-ui
import { Button, CardActionArea, Grid, Stack, Typography } from '@mui/material';

// project import
import MainCard from 'components/MainCard';
import { useEffect, useMemo, useState } from 'react';
import { getUserData, handleAsyncCall, isUserLoggedIn, useLocalStorage } from 'utils/common';
import { sessionConfig } from 'utils/constant';
import userAccessService from 'services/userAccess';
import { Camera, File, Loader, Map, PenTool, Settings, TrendingUp, Printer } from 'react-feather';
import useMain from 'hooks/useMain';
import { completeMenuList, setMenuList, setShowDrawer, setState } from 'store/reducers/menu';

import AppRegistrationRounded from '@mui/icons-material/AppRegistrationRounded';
import ShareLocationRounded from '@mui/icons-material/ShareLocationRounded';
import VideocamOutlined from '@mui/icons-material/VideocamOutlined';
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined';
import ArchitectureRounded from '@mui/icons-material/ArchitectureRounded';
import MyLocationRounded from '@mui/icons-material/MyLocationRounded';
import SettingsApplicationsOutlined from '@mui/icons-material/SettingsApplicationsOutlined';
import { rFetchProductList } from 'store/reducers/comModule';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ProductGraphCrad from 'components/ProductGraphCard';
// ==============================|| SAMPLE PAGE ||============================== //

const ProductPage = () => {
  const { t, useNavigate, dispatch, useSelector, useLocation } = useMain();
  const [block, setBlock] = useState(false);
  const navigate = useNavigate();
  const { getStorage, setStorage, removeStorage } = useLocalStorage();
  const products = useSelector((s) => s.comModule.products);
  const userData = getStorage(sessionConfig.userData);
  const location = useLocation();

  const IconBase = ({ IconName, ...props }) => {
    return <IconName {...props} />;
  };

  const prodListWithGraph = useMemo(() => {
    const normalUserProdList = products.map((props) => {
      const returnAttr = () => {
        switch (props.ProdName) {
          case 'Admin':
            return {
              Icon: SettingsApplicationsOutlined,
              link: '/userAdmin',
              ProdName: 'USERADMIN',
              style: { color: '#54acd3' }
            };
          case 'Location Tracking (GPS)':
            return {
              Icon: MyLocationRounded,
              link: '/functions/realtimeMapGps',
              ProdName: 'LOCATION_TRACKING_GPS'
            };

          default:
            return {
              Icon: AppRegistrationRounded,
              link: '/project',
              ProdName: 'APPLICATION',
              style: { color: '#dd2fcf' }
            };
        }
      };

      return {
        ...props,
        ...returnAttr()
      };
    });

    return normalUserProdList;
  }, [products]);

  useEffect(() => {
    if (userData?.navigate && !_.isEmpty(prodListWithGraph)) {
      const targetP = prodListWithGraph.find((p) => p.link === userData?.navigate);
      if (targetP?.Id) {
        setStorage(sessionConfig.product, { ProdName: targetP.ProdName, Id: targetP.Id });
        navigate(userData.navigate);
      }
    }
  }, [userData, prodListWithGraph]);

  useEffect(() => {
    if (isUserLoggedIn()) {
      dispatch(setMenuList(completeMenuList.filter(({ id }) => id !== 'project')));
      dispatch(rFetchProductList());
    } else {
      navigate('/login');
    }
  }, []);

  // if (!isUserLoggedIn()) {
  //   <Loader />;
  // }

  return (
    <Grid container spacing={2} width="100%">
      {prodListWithGraph.map(({ Icon, ProdName, link, Id, style }, i) => {
        return (
          <Grid item xs={12} sm={4} key={`${ProdName}`}>
            {/* <MainCard> */}
            {/* <Grid sx={{ alignItems: 'center'}} container direction="row" spacing={2}> */}
            {/* <Grid
                  item
                  sx={{
                    svg: {
                      width: '80px',
                      height: '80px'
                    }
                  }}
                >
                  <Icon />
                </Grid>
                <Grid >
                  {t(ProdName)}                  
                </Grid>
                <Grid 
                  sx={{
                    svg: {
                      width: '50px',
                      height: '50px'
                    }
                  }}>
                  <KeyboardArrowRightIcon/>
                </Grid> */}

            {/* <Grid item 
                    sx={{
                    svg: {
                      width: '50px',
                      height: '50px'
                    },
                  }}>
                  <Button
                    startIcon={IconBase({IconName: Icon, style})}
                    variant="outlined"
                    onClick={(e) => {
                      if (Id) {
                        setStorage(sessionConfig.product, { ProdName, Id });
                      }
                      navigate(link);
                    }}
                    endIcon={<KeyboardArrowRightIcon/>}
                    sx={{borderRadius:"20px"}}
                  >
                    <Typography style={{color:'black'}}>{t(ProdName)}</Typography>                   
                  </Button>
                </Grid> */}
            {/* </Grid> */}
            {/* </MainCard> */}
            <CardActionArea
              onClick={(e) => {
                if (Id) {
                  setStorage(sessionConfig.product, { ProdName, Id });
                }
                navigate(link);
              }}
              sx={{ borderRadius: '10px', '& .MuiCardActionArea-focusHighlight': { background: 'transparent' } }}
            >
              <ProductGraphCrad
                Content={
                  <Stack
                    direction="row"
                    sx={{
                      svg: {
                        width: '50px',
                        height: '50px'
                      }
                    }}
                  >
                    {IconBase({ IconName: Icon, style })}

                    <Typography display="flex" alignItems="center" p={2}>
                      {t(ProdName)}
                    </Typography>
                  </Stack>
                }
              />
            </CardActionArea>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProductPage;
